import "./App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Trust } from "./components/Trust";
import { Services } from "./components/Services";
import { Fleet } from "./components/Fleet";
import { Clientele } from "./components/Clientele";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { CTABanner } from "./components/CTABanner";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { MobileStickyCTA } from "./components/MobileStickyCTA";
import useReveal from "./hooks/useReveal";

function App() {
    useReveal();
    return (
        <div className="App bg-[#0A0A0A] text-white min-h-screen">
            <Navbar />
            <main>
                <Hero />
                <Trust />
                <Services />
                <Fleet />
                <Clientele />
                <CTABanner />
                <About />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <MobileStickyCTA />
        </div>
    );
}

export default App;
